/** @ngInject */
export class FilterUtil {

    static constructFilter(data, $scope) {
        let filter = {};

        if ($scope.language) {
            filter.language = $scope.language;
        }

        if ($scope.date) {
            filter.dateTo = $scope.date;
        } else if ($scope.$root && $scope.$root.pickedDate) {
            filter.dateTo = $scope.$root.pickedDate;
        }

        if ($scope.predefinedQuery) {
            filter.predefinedQuery = $scope.predefinedQuery;
            filter.dateFrom = $scope.dateFrom;
            return filter;
        }

        if (!_.isNil($scope.filter)) {
            if ((!$scope.filter.kind || $scope.filter.kind === 'country') && ($scope.filter.country === "" || $scope.filter.code === "")) {
                filter.country = [""]; // ARSWEB-419: some accounts have no country
            } else if ((!$scope.filter.kind || $scope.filter.kind === 'bank') && ($scope.filter.bank === "" || $scope.filter.code === "" )) {
                filter.bank = [""]; // ARSWEB-419: some accounts have no bank
            } else if ($scope.filter.code) {
                filter[$scope.filter.kind] = [];
                filter[$scope.filter.kind].push($scope.filter.code);
            } else if ($scope.filter.kind === 'composite') {
                filter = angular.copy($scope.filter);
            }

            if (!_.isNil($scope.subFilter)) {
                if ((!$scope.subFilter.kind || $scope.subFilter.kind === 'country') && $scope.subFilter.country === "" &&
                    !Object.prototype.hasOwnProperty.call(filter,"country")) {
                    filter.country = [""]; // ARSWEB-419: some accounts have no country
                } else if ((!$scope.subFilter.kind || $scope.subFilter.kind === 'bank') && $scope.subFilter.bank === "" &&
                    !Object.prototype.hasOwnProperty.call(filter,"bank")) {
                    filter.bank = [""]; // ARSWEB-419: some accounts have no bank
                } else {
                    if (!Object.prototype.hasOwnProperty.call(filter, $scope.subFilter.kind)) {
                        filter[$scope.subFilter.kind] = [];
                    }
                    filter[$scope.subFilter.kind].push($scope.subFilter.code);
                }
            }
        }

        if (data) {
            data.forEach(it=> {
                if (it) {
                    const value = it.code ? it.code : "";
                    let kind = it.kind;

                    if (!kind) {
                        if (it.country === "") {
                            kind = "country"; // ARSWEB-419: some accounts have no country
                        } else if (it.bank === "") {
                            kind = "bank"; // ARSWEB-419: some accounts have no bank
                        }
                    }

                    if (_.isNil(filter[kind])) {
                        filter[kind] = [];
                    }

                    if (it.kind === 'freeText') {
                        filter[kind].push(it.name);
                    } else {
                        filter[kind].push(kind === 'country' && it.name ? it.name : value); // ARSWEB-534: filter by country name instead of country code
                    }
                }
            });
        }

        if ($scope.searchInput) {
            filter['$'] = $scope.searchInput;
        }

        return filter;
    }

    static constructDefaultFilter($scope, filter) {
        if (_.isNil(filter)) {
            filter = {};
        }

        if (!_.isNil($scope.filter)) {
            if ($scope.filter.kind === 'dateRange') {
                filter[$scope.filter.kind] = $scope.filter;
            } else if ($scope.filter.kind !== 'composite') {
                filter[$scope.filter.kind] = [$scope.filter];
            }
        }

        return filter;
    }
}
